export const DiscordSmallIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <path
      fill='#fff'
      d='M15.545 4.995a13.354 13.354 0 0 0-3.257-.993.05.05 0 0 0-.053.024c-.15.266-.285.54-.406.82a12.38 12.38 0 0 0-3.658 0 8.24 8.24 0 0 0-.412-.82.051.051 0 0 0-.053-.024c-1.124.19-2.219.525-3.255.993a.046.046 0 0 0-.022.018c-2.074 3.05-2.642 6.024-2.364 8.96a.053.053 0 0 0 .021.037 13.354 13.354 0 0 0 3.996 1.988.053.053 0 0 0 .056-.019c.309-.413.582-.85.817-1.307a.05.05 0 0 0-.027-.07 8.809 8.809 0 0 1-1.249-.584.05.05 0 0 1-.025-.04.05.05 0 0 1 .02-.043c.084-.062.168-.127.248-.192a.05.05 0 0 1 .052-.007c2.618 1.177 5.454 1.177 8.041 0a.05.05 0 0 1 .053.007c.08.064.164.13.25.191a.05.05 0 0 1 .02.043.05.05 0 0 1-.024.041 8.26 8.26 0 0 1-1.25.584.052.052 0 0 0-.03.03.05.05 0 0 0 .002.04c.24.455.513.892.817 1.308a.051.051 0 0 0 .056.018 13.309 13.309 0 0 0 4-1.987.049.049 0 0 0 .02-.036c.335-3.396-.557-6.346-2.364-8.96a.04.04 0 0 0-.02-.02Zm-8.199 7.19c-.788 0-1.438-.712-1.438-1.586 0-.874.637-1.587 1.438-1.587.807 0 1.45.719 1.438 1.587 0 .874-.637 1.587-1.438 1.587Zm5.317 0c-.788 0-1.438-.712-1.438-1.586 0-.874.637-1.587 1.438-1.587.807 0 1.45.719 1.438 1.587 0 .874-.63 1.587-1.438 1.587Z'
    />
  </svg>
);
